import { SCROLL_RELATED_KEYS, PALANTIR_SCROLLBAR_OVERRIDE_VARIABLE } from './constants';
import type { ToggleWindowEventOptions } from './utils';
import {
  checkIfBrowserSupportsPassive,
  determineScrollEventOptionsAndName,
  isIgnoredElement,
  overrideScrollbarOnIgnoredContainers,
  toggleWindowEvents,
} from './utils';

export function createScrollToggle() {
  if (typeof window === 'undefined') {
    throw new TypeError('This function should be called in the browser');
  }

  // Helper function for disabling scroll
  // eslint-disable-next-line unicorn/consistent-function-scoping
  const preventDefault = (evt: Event) => {
    if (isIgnoredElement(evt.target as HTMLElement)) return;

    evt.preventDefault();
  };

  // eslint-disable-next-line unicorn/consistent-function-scoping
  const preventDefaultForScrollKeys = (evt: KeyboardEvent) => {
    if (!SCROLL_RELATED_KEYS.has(Number(evt.code))) return;

    evt.preventDefault();
  };

  const passiveSupported = checkIfBrowserSupportsPassive();
  const { scrollEventName, scrollEventListenerOptions } =
    determineScrollEventOptionsAndName(passiveSupported);

  const WINDOW_EVENTS: ToggleWindowEventOptions[] = [
    {
      eventName: 'DOMMouseScroll' as unknown as keyof WindowEventMap,
      handler: preventDefault,
      options: false,
    },
    {
      eventName: scrollEventName,
      handler: preventDefault,
      options: scrollEventListenerOptions,
    },
    {
      eventName: 'touchmove',
      handler: preventDefault,
      options: scrollEventListenerOptions,
    },
    {
      eventName: 'keydown',
      handler: preventDefaultForScrollKeys,
    },
  ];

  const disableScroll = () => {
    toggleWindowEvents(WINDOW_EVENTS, 'add');

    document.documentElement.style.setProperty(PALANTIR_SCROLLBAR_OVERRIDE_VARIABLE, 'none');

    overrideScrollbarOnIgnoredContainers();
  };

  // call this to Enable
  const enableScroll = () => {
    toggleWindowEvents(WINDOW_EVENTS, 'remove');

    document.documentElement.style.removeProperty(PALANTIR_SCROLLBAR_OVERRIDE_VARIABLE);
  };

  return {
    disableScroll,
    enableScroll,
  };
}
